import teamsApi from "@/api/teams";
import events from "@/events/index";

const state = {
  loading: false,
  error: null,
  members: [],
  maxSeats: null,
  maxSeatsToDisplay: null,
  filledSeats: null,
  hasTeam: null,
  inviteLink: null,
  memberToRemove: null,
  statusModalType: "success",
  companyName: null,
  teamName: null
};

const mutations = {
  hasTeam: (state, payload) => {
    state.hasTeam = payload;
  },
  members: (state, payload) => {
    state.members = payload;
  },
  maxSeats: (state, payload) => {
    state.maxSeats = payload;
  },
  maxSeatsToDisplay: (state, payload) => {
    state.maxSeatsToDisplay = payload;
  },
  filledSeats: (state, payload) => {
    state.filledSeats = payload;
  },
  inviteLink: (state, payload) => {
    state.inviteLink = payload;
  },
  loading: (state, payload) => {
    state.loading = payload;
  },
  error: (state, payload) => {
    state.error = payload;
  },
  memberToRemove: (state, payload) => {
    state.memberToRemove = payload;
  },
  statusModalType: (state, payload) => {
    state.statusModalType = payload;
  },
  companyName: (state, payload) => {
    state.companyName = payload;
  },
  teamName: (state, payload) => {
    state.teamName = payload;
  }
};

const actions = {
  loadTeam: ({ commit }) => {
    return teamsApi
      .loadTeam()
      .then(res => {
        if (res.status === "error") {
          throw res.message;
        } else {
          commit("hasTeam", true);
          commit("members", res.members);
          commit("inviteLink", res.inviteLink);
          commit("filledSeats", res.filledSeats);
          commit("maxSeats", res.maxSeats);
          commit("maxSeatsToDisplay", res.maxSeatsToDisplay);
          commit("companyName", res.companyName);
          commit("teamName", res.teamName);

          events.track("teams_settings_members_shown", "1-show", res.filledSeats);
        }
      })
      .catch((err) => {
        commit("hasTeam", false);
        commit("error", err);
      })
      .finally(() => {
        events.emit("page-loaded");
      });
  },
  triggerRemoveUserModal: ({ commit }, member) => {
    events.emit("modal:remove-team-member-modal:open");
    commit("memberToRemove", member);
  },
  removeUserFromTeam: ({ state, commit, dispatch }) => {
    commit("loading", true);
    return teamsApi
      .removeUserFromTeam(state.memberToRemove.id)
      .then((res) => {
        if (res.status === "error") {
          throw res.message;
        } else {
          commit("statusModalType", "success");
          events.emit("modal:status-modal-team-management:open");
          events.track("teams_settings_user_removed", "1-trigger");
        }
      })
      .catch((err) => {
        commit("error", err);
        commit("statusModalType", "error");
        events.emit("modal:status-modal-team-management:open");
      })
      .finally(() => {
        dispatch("loadTeam");
        commit("loading", false);
      });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
